if (!customElements.get('c-image-curtain')) {
  customElements.define(
    'c-image-curtain',
    class ImageCurtain extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.c-backed-by-clinical-research__range');
        this.tags = this.querySelectorAll('.c-backed-by-clinical-research__tag');

        if (!this.range) return;

        // Fade a tag out once the divider reaches it, instead of letting the divider slice through it.
        this.updateTags = () => {
          const curtain = (this.offsetWidth * this.range.value) / 100;

          this.tags.forEach((tag) => {
            const isLeft = tag.classList.contains('c-backed-by-clinical-research__tag--left');
            const isCovered = isLeft ? tag.offsetLeft + tag.offsetWidth > curtain : tag.offsetLeft < curtain;

            tag.classList.toggle('is-hidden', isCovered);
          });
        };

        this.updateCurtain = () => {
          this.style.setProperty('--sl-c-backed-by-clinical-research-curtain-position', `${this.range.value}%`);
          this.updateTags();
        };

        this.range.addEventListener('input', this.updateCurtain);
        this.resizeObserver = new ResizeObserver(this.updateTags);
        this.resizeObserver.observe(this);
        this.updateCurtain();
      }

      disconnectedCallback() {
        this.range?.removeEventListener('input', this.updateCurtain);
        this.resizeObserver?.disconnect();
      }
    }
  );
}
